import React from 'react';

const pushToDataLayer = ( data ) => {
    // console.log(data);
    window.dataLayer.push(data);
    return null; // Since this is a utility component, it doesn't render anything
};

export default pushToDataLayer;